import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  /* padding: 12px 20px;
  background: var(--filter-bar-bg); */
  align-items: center;
  /* height: 84px; */
  flex-wrap: wrap;
  row-gap: 10px;
  /* .label-wrapper {
    font-size: 16px;
    font-weight: 900;
    color: var(--theme-text);
    font-family: "Lato";
    font-style: normal;
  } */
`;

export const CurrentPageContainer = styled.div`
  background-color: #fafcff;
  padding: 27px 20px 15px 33px;
  width: 100%;
  height: 100%;
  position: relative;
  @media (max-width: 850px) {
    padding: 13px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 19px;
  height: 100%;
  max-height: calc(100vh - 103px);
  overflow: auto;
  > div {
    flex: 1;
    box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
    padding: 0 20px;
    background: var(--inner-section-bg);
  }
  @media (max-width: 850px) {
    padding: 0;
    ::-webkit-scrollbar:horizontal {
      display: none;
    }
  }
`;

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d1d0cb;
  min-height: 70px;
  padding-bottom: 9px;
  margin-bottom: 18px;
  .icon {
    cursor: pointer;
    width: 22px;
    path {
      fill: #9ba0a4;
    }
  }
  h2 {
    font-size: 16px;
    line-height: 150.5%;
  }
  button {
    background: #ffffff;
    border: 1px solid #636f7c;
    border-radius: 6px;
    font-size: 13px;
    line-height: 150.5%;
    gap: 7px;
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 15px;
  }
`;

export const BodyWrapper = styled.div`
  /* height: 500px; */
  /* .k-chart {
    height: 500px;
  } */

  .k-chart {
    min-width: 850px;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .playing-cars {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #d1d0cb;
    padding: 10px 0;
    flex-direction: column;
    gap: 10px;
  }
`;

export const DetailSideTab = styled.div`
  max-width: 315px;
  min-width: 315px;
  padding: 0 16.5px !important;
  box-shadow: none !important;
  background-color: transparent !important;
  position: sticky;
  top: 0;
  .heading {
    padding-bottom: 9px;
    border-bottom: 1px solid rgba(209, 208, 203, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    h2 {
      font-weight: 700;
      font-size: 16px;
      line-height: 150.5%;
    }
  }
  @media (max-width: 850px) {
    position: absolute;
    background-color: #fff !important;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;
export const CardWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 200px);
`;

export const Card = styled.div`
  display: grid;
  grid-gap: 16px;
  padding: 10px 15px 15px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin-bottom: 15px;
  .heading {
    font-size: 20px;
    line-height: 150.5%;
    font-weight: 500;
  }
  .date-hole-number {
    font-size: 14px;
    line-height: 150.5%;
  }
  .behind-time {
    font-size: 14px;
    line-height: 150.5%;
    margin: 20px 0px 20px 0px;
    color: #e2bf01;
  }
  .action-btn {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    button {
      font-family: "Roboto";

      &.active {
        background-color: var(--theme-background);
        color: var(--theme-text);
        border: none;
        :disabled {
          opacity: 0.5;
        }
      }
    }
  }
`;

export const NotificationTabsContainer = styled.div`
  .MuiBox-root {
    border-color: var(--table-un-check-color);
  }
  .Mui-selected {
    color: var(--text-primary) !important;
  }
  .MuiTabs-indicator {
    background-color: var(--theme-background) !important;
  }
  .MuiButtonBase-root {
    font-size: 13px;
    line-height: 150.5%;
    padding: 4px 0;
    min-height: 28px;
    text-transform: inherit;
    min-width: 75px;
  }
  .MuiTabs-flexContainer {
    gap: 10px;
  }
  .MuiTabs-root {
    min-height: 28px;
  }
  .send-btn {
    min-width: 69px;
  }
  .text-area {
    width: 100% !important;
    max-width: 100%;
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 13px 16px;
    font-size: 13px;
    line-height: 150.5%;
    margin-bottom: 20px;
    ::-webkit-input-placeholder {
      font-size: 13px;
      line-height: 150.5%;
      color: #000000;
      opacity: 0.4;
    }

    :-ms-input-placeholder {
      font-size: 13px;
      line-height: 150.5%;
      color: #000000;
      opacity: 0.4;
    }

    ::placeholder {
      font-size: 13px;
      line-height: 150.5%;
      color: #000000;
      opacity: 0.4;
    }
  }
  .MuiTabPanel-root {
    padding: 20px 0 0;
  }
`;

export const CarDetailTabsContainer = styled.div``;

export const CarDetailModalContainer = styled.div`
  .header {
    padding: 43px 26px 19px;
    background: #f2f6fa;
    p {
      font-size: 30px;
      line-height: 150.5%;
      color: #000;
    }
  }
`;
